import { Controller } from '@hotwired/stimulus';

import ajax from '@/modules/ajax';
import Autocomplete from '@/modules/autocomplete';
import HandlebarsHelpers from '@/modules/handlebars_helpers';
import ModuleLoader from '@/modules/module_loader';
import TemplatesCommon from '@/pages/common/templates';
import TemplatesEvents from '@/pages/events/templates';

export default class extends Controller {
  connect() {
    this.examinerField = $('#examiner_id');
    this.examinersWrapper = $('#examiners');
    this.options = ModuleLoader.getOptions();
    this.prospectField = $('#prospect_id');
    this.prospectsWrapper = $('#prospects');

    HandlebarsHelpers.init();

    if (this.examinerField.length) {
      this.#examinerSearcher();
      this.#bindDestroy(this.examinersWrapper);
    }

    if (this.prospectField.length) {
      this.#prospectSearcher();
      this.#bindDestroy(this.prospectsWrapper);
    }

    this.#bindOptions();
  }

  #addItem(wrapper, suggestion) {
    const persistedItem = wrapper.find(`[data-uuid="${suggestion.id}-${this.#getRole()}"]`);

    if (persistedItem.length) {
      persistedItem.hide().fadeIn();
    } else {
      this.#save(suggestion, wrapper);
    }
  }

  #bindDestroy(wrapper) {
    wrapper.on('click', '.participant__item__remove', (event) => {
      this.#handleDestroy(event.currentTarget, wrapper);
    });
  }

  #bindOptions() {
    this.examinerComplety = this.examinerField.data('complety');
    this.prospectComplety = this.prospectField.data('complety');

    $('.trails__options__role')
      .find(':radio')
      .on('change', () => {
        this.examinerComplety.hide();
        this.prospectComplety.hide();
        this.examinerField.focus();
      });
  }

  #checkItems(wrapper) {
    const count = wrapper.children('.participant__item').length;

    count > 0 ? wrapper.find('.trail__empty').hide() : wrapper.find('.trail__empty').show();
  }

  #createUrl(wrapper) {
    const path = wrapper.data('path');

    return `/eventos/admin/${this.options.eventId}/trilhas/${this.options.trailId}/${path}`;
  }

  #examinerSearcher() {
    new Autocomplete({
      cache: false,
      field: this.examinerField,
      keys: ['name', 'user.email', 'user.name'],
      params: { role: this.#getRole, trail_id: this.options.trailId },
      prevent: ['selected'],
      templates: { none: TemplatesCommon.teachers.search.none, search: TemplatesCommon.teachers.search },
    }).create();

    this.examinerField.on('complety:selected', (_event, suggestion) => {
      this.#addItem(this.examinersWrapper, suggestion);

      const field = this.examinerField[0];

      field.value = '';
      field.focus();
    });
  }

  #getRole() {
    return document.querySelector('input[name="role[role]"]:checked').value;
  }

  #handleDestroy(button, wrapper) {
    ajax({
      done: () => {
        $(button)
          .closest('.participant__item')
          .fadeOut(() => {
            $(button).trigger('mouseout').remove();

            this.#checkItems(wrapper);
          });
      },
      method: 'DELETE',
      url: `${this.#createUrl(wrapper)}/${button.getAttribute('data-id')}`,
    });
  }

  #onSave(json, wrapper) {
    const item = TemplatesEvents.trails.participant({
      avatar: json.avatar,
      email: json.email,
      id: json.id,
      name: json.name,
      role: json.role,
      url: json.url,
      uuid: json.uuid,
      x_image: json.x_image,
    });

    $(item).appendTo(wrapper);

    this.#checkItems(wrapper);
  }

  #prospectSearcher() {
    new Autocomplete({
      cache: false,
      field: this.prospectField,
      keys: ['email', 'name'],
      params: { role: this.#getRole, trail_id: this.options.trailId },
      prevent: ['selected'],
      templates: { none: TemplatesCommon.users.search.none, search: TemplatesCommon.users.search },
    }).create();

    this.prospectField.on('complety:selected', (_event, suggestion) => {
      this.#addItem(this.prospectsWrapper, suggestion);

      const field = this.prospectField[0];

      field.value = '';
      field.focus();
    });
  }

  #save(suggestion, wrapper) {
    ajax({
      body: { id: suggestion.id, role: this.#getRole() },
      method: 'POST',
      done: (json) => this.#onSave(json, wrapper),
      url: this.#createUrl(wrapper),
    });
  }
}
